import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import moment from "moment";
import FilterOperatorDisplay from "./FilterOperatorDisplay";
import { isRelativeFilterConditionValueType, } from "../../../Domain/ReportBuilder/FilterCondition.model";
import { getIdProvider } from "../../../../util/IDProvider";
const DATE_FORMAT = "M/D/YYYY h:mma";
const ReportDetails = (props) => {
    const FieldDisplay = (fieldDisplayProps) => {
        return (_jsxs("div", { className: "form-group", children: [_jsx("label", { children: fieldDisplayProps.label }), _jsx("div", { children: fieldDisplayProps.value })] }));
    };
    function getValueDisplay(fc) {
        if (isRelativeFilterConditionValueType(fc.filterConditionValueType) &&
            fc.value &&
            !Number.isNaN(fc.value)) {
            return Math.abs(parseInt(fc.value, 10));
        }
        return fc.displayValue;
    }
    function getValueTypeDisplay(fc) {
        if (fc.filterConditionValueType === "RELATIVE_DAYS") {
            return "days";
        }
        if (fc.filterConditionValueType === "RELATIVE_WEEKS") {
            return "weeks";
        }
        if (fc.filterConditionValueType === "RELATIVE_MONTHS") {
            return "months";
        }
        if (fc.filterConditionValueType === "RELATIVE_YEARS") {
            return "years";
        }
        return "";
    }
    function getRelativeOptionDisplay(fc) {
        if (isRelativeFilterConditionValueType(fc.filterConditionValueType)) {
            if (fc.value && !Number.isNaN(fc.value)) {
                if (parseInt(fc.value, 10) < 0) {
                    return "ago";
                }
                return "from now";
            }
        }
        return "";
    }
    const idProvider = getIdProvider();
    const { filter } = props;
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "modal-header", children: _jsxs("h5", { className: "modal-title", children: [filter && filter.name, " "] }) }), _jsx("div", { className: "modal-body", children: filter && (_jsxs(_Fragment, { children: [_jsx(FieldDisplay, { label: "ID", value: filter.id }), filter.description && (_jsx(FieldDisplay, { label: "Description", value: filter.description })), _jsx(FieldDisplay, { label: "Created", value: `${moment(filter.createdDate).format(DATE_FORMAT)} by ${filter.createdBy.firstName} ${filter.createdBy.lastName}` }), _jsx(FieldDisplay, { label: "Modified", value: `${moment(filter.modifiedDate).format(DATE_FORMAT)} by ${filter.modifiedBy.firstName} ${filter.modifiedBy.lastName}` }), _jsx(FieldDisplay, { label: "Filter Source", value: filter.filterSource.displayName }), _jsx(FieldDisplay, { label: "Last Run Date", value: moment(filter.lastRunDate).format(DATE_FORMAT) }), _jsxs("div", { className: "form-group", children: [_jsx("label", { children: "Selected Columns" }), _jsx("div", { children: filter.selectedColumns
                                        .map((sc) => sc.filterSourceColumn &&
                                        sc.filterSourceColumn.displayName)
                                        .join(", ") })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { children: "Filters" }), _jsx("div", { children: filter.filterConditions.map((fc) => (_jsxs("div", { children: [fc.filterSourceColumn.displayName, " ", _jsx(FilterOperatorDisplay, { operatorName: fc.filterOperator }), " ", getValueDisplay(fc), " ", getValueTypeDisplay(fc), " ", getRelativeOptionDisplay(fc)] }, idProvider.getAndIncrement()))) })] })] })) }), _jsx("div", { className: "modal-footer", children: _jsxs("button", { type: "button", className: "btn btn-outline-secondary", "data-dismiss": "modal", children: [_jsx("span", { className: "fa fa-times", "aria-hidden": "true" }), " Close"] }) })] }));
};
export default ReportDetails;
